import styled from "styled-components";

const DeliveryItemsStyled = styled.div`
   width: 100%;
   display: flex;
   flex-direction: column;
   gap:20px;
   min-height: 670px;
    position: relative;

.itemsPanel::-webkit-scrollbar {
    width: 2px; 
}

.statusWrapper {
    display: flex;
    width: 100%;
}

.itemsPanel::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;  
}

.itemsPanel::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px;  
    border: 2px solid #f1f1f1; 
}

.historySection {
    margin-top: 16px;
   display: flex;
   gap: 8px;
   align-items: center;
   justify-content: start;
   color: #008755;
   cursor: pointer;
   font-size: 1.6rem;
   font-weight: 700;
   font-family: ${props => props.theme.fontBold};
}

.itemsPanel::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.itemsPanel::-moz-scrollbar {
    width: 8px;
}

.itemsPanel::-moz-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px;
}

.itemsPanel::-moz-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.itemsPanel {
   scrollbar-width: thin;
   scrollbar-color: #CFD0CF transparent;
   max-height: 600px;
   overflow-y: scroll; 
}

.itemAmount {
   margin-bottom: 16px;
}

.noItemsCardWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

     & > div {
        width: 380px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
     }

     & > div p {
        text-align: center;
        font-size: 1.3rem;
        color: #757575;
        font-weight: 400;
        line-height: 20px;
     }
}



`

export { DeliveryItemsStyled };
